import React, { useMemo } from 'react'
import './priceStyle.css'

interface PriceComponentProps {
  price?: number
}
const PriceComponent: React.FC<PriceComponentProps> = ({ price }) => {
  const priceValue = useMemo(() => {
    if (!price) {
      return ''
    }
    if ((10 * price) % 10 !== 0) {
      return price.toFixed(2)
    }
    return price
  }, [price])
  return (
    <>
      <div
        className="inline-flex flex-row align-items-end"
        style={{ float: 'right' }}
      >
        <>
          <p className="priceCustom">R{priceValue} excl. VAT (per search)</p>
        </>
      </div>
    </>
  )
}
export default PriceComponent
